import {Model} from "@lernetz/ts-lib";
import {ToolDto} from "./tool.interface";

export class Tool extends Model {
    constructor(dto: ToolDto) {
        super(dto);
    }
}
